module.exports = __webpack_public_path__ + "img/img2.dce7630b.png";